/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimDataResponseDto } from '../models/clm-claim-data-response-dto';


/**
 * the ClaQueryReadClaim API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryReadClaimService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimNumberGet
   */
  static readonly ClaimNumberGetPath = '/claim/{number}';

  /**
   * Get claim details by claimNumber.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimNumberGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimNumberGet$Response(params: {
    number: string;

    /**
     * By default, the claim will be returned in the language written during claim registration
     */
    language?: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmClaimDataResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryReadClaimService.ClaimNumberGetPath, 'get');
    if (params) {
      rb.path('number', params.number, {});
      rb.query('language', params.language, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmClaimDataResponseDto>;
      })
    );
  }

  /**
   * Get claim details by claimNumber.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimNumberGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimNumberGet(params: {
    number: string;

    /**
     * By default, the claim will be returned in the language written during claim registration
     */
    language?: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<ClmClaimDataResponseDto> {

    return this.claimNumberGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmClaimDataResponseDto>) => r.body as ClmClaimDataResponseDto)
    );
  }

}
